
import ImageMobile from "../../Assets/TalentOnDemand/whats-included-mobile.png";
import Image from "../../Assets/TalentOnDemand/whats-included.png";
const TalentOnDemandMainWhatsIncluded = () => {

    return (
        <section className="w-full h-full bg-white flex flex-col items-center justify-between gap-4 py-8 md:pt-16 ">
            <div className="px-4 lg:px-0 flex flex-col">
                <h2 className="text-2xl md:text-5xl xl:text-7xl text-black font-semibold text-center flex items-start justify-center">
                    What's Included
                </h2>
                <a
                    target="_blank"
                    href={"/talent-ondemand/features"}
                    className="bg-transparent my-5 mx-auto hover:bg-brand-green hover:text-white border border-black hover:border-brand-green text-black font-medium px-6 py-3 rounded-full transition-all duration-200"
                >
                    See More Details
                </a>
                <h4 className="text-center w-full mx-auto md:w-fit text-white md:text-2xl mt-4">
                    Available 24/7
                </h4>
                <img src={Image} alt="What's included" className="hidden md:block object-contain w-full h-auto max-w-[1200px] mx-auto" />
                <img src={ImageMobile} alt="What's included" className="block md:hidden object-contain w-full h-auto max-w-[1200px] mx-auto" />
            </div>
        </section >
    );
}

export default TalentOnDemandMainWhatsIncluded;